import React from 'react'
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';

export default function Sidebar() {
    const Logout = ()=>{
        sessionStorage.removeItem('__token');
        toast.success('Logout Successfull')
        setTimeout(()=>{
          window.location = '/'
        },600)
      }
  return (
    <div>
      <div className="sidebar" id="sidebar">
  <div className="sidebar-inner slimscroll">
    <div id="sidebar-menu" className="sidebar-menu">
      <ul>
        <li className="active">
          <Link className="active" to="/Admin/dashboard">
            <img src="/assets/img/icon/menu-icon-01.svg" alt="img" />{" "}
            <span>Dashboard</span>
          </Link>
        </li>
        <li>
          <Link to="/Admin/UserList">
            <img src="/assets/img/icon/menu-icon-02.svg" alt="img" />{" "}
            <span>Users</span>
          </Link>
        </li>
        <li>
          <Link to="/Admin/Basecoins">
            <img src="/assets/img/icon/menu-icon-02.svg" alt="img" />{" "}
            <span>BaseCoins</span>
          </Link>
        </li>
        <li>
          <Link to="/Admin/SwapTrans">
            <img src="/assets/img/icon/menu-icon-02.svg" alt="img" />{" "}
            <span>Swap Transactions</span>
          </Link>
        </li>
        <li>
          <Link to="/Admin/StakeTrans">
            <img src="/assets/img/icon/menu-icon-02.svg" alt="img" />{" "}
            <span>Stake Transactions</span>
          </Link>
        </li>
        <li>
          <Link to="/Admin/TokenTrans">
            <img src="/assets/img/icon/menu-icon-02.svg" alt="img" />{" "}
            <span>Token Transactions</span>
          </Link>
        </li>
        <li>
          <Link to="/Admin/CoinTrans">
            <img src="/assets/img/icon/menu-icon-02.svg" alt="img" />{" "}
            <span>Coin Transactions</span>
          </Link>
        </li>
       
      
        {/* <li>
          <Link to="/admin/MyWallet">
            <img src="/assets/img/icon/menu-icon-05.svg" alt="img" />{" "}
            <span>My Wallet</span>
          </Link>
        </li>
        <li>
          <Link to="/admin/tickets?q=open">
            <img src="/assets/img/icon/menu-icon-05.svg" alt="img" />{" "}
            <span>Support Tickets</span>
          </Link>
        </li>
     
        <li>
          <Link to="/Admin/Settings">
            <img src="/assets/img/icon/menu-icon-12.svg" alt="img" />{" "}
            <span>Settings</span>
          </Link>
        </li>
        <li>
          <Link to="/admin/pushNotify">
            <img src="/assets/img/icon/menu-icon-04.svg" alt="img" />{" "}
            <span>Push Notifications</span>
          </Link>
        </li> */}
        <li>
          <Link to="/admin/changePassword">
            <img src="/assets/img/icon/menu-icon-04.svg" alt="img" />{" "}
            <span>Change Password</span>
          </Link>
        </li>
       
      </ul>
    
     
      <div className="logout-btn">
        <a onClick={Logout} className="btn btn-primary">
          <img src="/assets/img/icon/lock-out.svg" className="me-2" alt="" />
          Logout
        </a>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}
